import { render, staticRenderFns } from "./CustomizeFields.vue?vue&type=template&id=489fade3&scoped=true&"
import script from "./CustomizeFields.vue?vue&type=script&lang=js&"
export * from "./CustomizeFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeFields.vue?vue&type=style&index=0&id=489fade3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fade3",
  null
  
)

export default component.exports